import Text from '@zenbusiness/zui/Text';
import PropTypes from 'prop-types';

const ErrorMessage = ({ message }) => (
  <Text
    color="red"
    size="md"
  >
    {message}
  </Text>
);

ErrorMessage.propTypes = {
  message: PropTypes.string.isRequired
};

export default ErrorMessage;
